import React from "react";

function Agames() {
  return (
    <>
      <div className="bx">
        The Legend of Zelda <br /> 4.8/5
      </div>
      <div className="bx">
        Read Dead Redemption <br />
        4.8/5
      </div>
      <div className="bx">
        Assassins's Creed Oddesey <br />
        4.6/5
      </div>
    </>
  );
}

export default Agames;
